import {Injectable} from '@angular/core';
import {DataService} from './data.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable()
export class RestService {
    baseURL: string;
    httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    constructor(
        private httpClient: HttpClient,
        private dataService: DataService) {
        this.baseURL = `${environment.baseUrl}/soc-admin/v1/`;
    }

    login(userCredentials: {}): Observable<any> {
        const callUrl = this.baseURL + 'login';
        const body = JSON.stringify(userCredentials);
        return this.httpClient.post(callUrl, body, this.httpOptions);
    }

    logout() {
        const callUrl = this.baseURL + 'logout';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    checkSession(sessionId: string) {
        const callUrl = this.baseURL + 'checksession';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', sessionId);
        return this.httpClient.get(callUrl, {headers});
    }

    updateAdminProfile(profile: any) {
        const callUrl = this.baseURL + 'profile';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.post(callUrl, JSON.stringify(profile), {headers});
    }

    getOverviewData() {
        const callUrl = this.baseURL + 'overview';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getOverviewOrdersByPlatform() {
        const callUrl = this.baseURL + 'overview/orders-by-platform';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getOverviewOrdersByPaymentMethod() {
        const callUrl = this.baseURL + 'overview/orders-by-payment-method';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getCars() {
        const callUrl = this.baseURL + 'cars';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getPendingVouchers() {
        const callUrl = this.baseURL + 'pendingvouchers';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getOrders(page: number, pageSize: number, phoneNumber: string, car: string, status: string, source: string,
              paymentMethod: string, exactCar: boolean = false) {
        let callUrl = this.baseURL + 'getorders?page=' + page + '&pageSize=' + pageSize;
        if (phoneNumber !== '') {
            callUrl += '&phoneNumber=' + encodeURIComponent(phoneNumber);
        }
        if (car !== '') {
            callUrl += '&car=' + encodeURIComponent(car);
        }
        if (status !== '') {
            callUrl += '&status=' + encodeURIComponent(status);
        }
        if (source !== '') {
            callUrl += '&source=' + encodeURIComponent(source);
        }
        if (paymentMethod !== '') {
            callUrl += '&paymentMethod=' + encodeURIComponent(paymentMethod);
        }
        if (exactCar) {
            callUrl += '&exactCar=true';
        }
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getOrderLocations(orderId: string) {
        const callUrl = this.baseURL + 'orderLocations/' + encodeURIComponent(orderId);
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getActiveOrder(carIdentifier: string) {
        const callUrl = this.baseURL + 'activeOrder/' + encodeURIComponent(carIdentifier);
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getPosTerminals() {
        const callUrl = this.baseURL + 'posterminals';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getPosAppVersion(deviceId: string) {
        const callUrl = this.baseURL + 'posappversion/' + encodeURIComponent(deviceId);
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    updatePosAppVersion(deviceId: string, posAppVersion: string) {
        const callUrl = this.baseURL + 'updateposappversion';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.post(callUrl, JSON.stringify({
            DeviceId: deviceId,
            PosAppVer: posAppVersion
        }), {headers});
    }

    updatePosTerminal(dataToSend: any) {
        const callUrl = this.baseURL + 'updateposterminal';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.post(callUrl, JSON.stringify(dataToSend), {headers});
    }

    resetPosPairingCode(idTerminal: string) {
        const callUrl = this.baseURL + 'resetpospairingcode';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.post(callUrl, JSON.stringify({IdTerminal: idTerminal}), {headers});
    }

    payPendingVoucher(dataToSend: any) {
        const callUrl = this.baseURL + 'pendingvoucherpay';
        const body = JSON.stringify(dataToSend);
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.post(callUrl, body, {headers});
    }

    getAirportCars() {
        const callUrl = this.baseURL + 'airportcars';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getOnlineCars() {
        const callUrl = this.baseURL + 'onlinecars';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getCarDetails(carIdentifier: string) {
        const callUrl = this.baseURL + 'cardetails/' + carIdentifier;
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getDriverHistory(driverId: string) {
        const callUrl = this.baseURL + 'driverhistory/' + driverId;
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    unpairDevice(carIdentifier: string) {
        const callUrl = this.baseURL + 'unpairdevice/' + carIdentifier;
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    getCarsOnMap() {
        const callUrl = this.baseURL + 'carsonmap';
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.get(callUrl, {headers});
    }

    updateDrinkSafe(dataToSend: any) {
        const callUrl = this.baseURL + 'set-drink-safe';
        const body = JSON.stringify(dataToSend);
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.post(callUrl, body, {headers});
    }

    updatePackage(dataToSend: any) {
        const callUrl = this.baseURL + 'set-package';
        const body = JSON.stringify(dataToSend);
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.post(callUrl, body, {headers});
    }

    suspendDriver(dataToSend: any) {
        const callUrl = this.baseURL + 'admin_suspend';
        const suspendBody = JSON.stringify(dataToSend);
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.post(callUrl, suspendBody, {headers});
    }

    unsuspendDriver(dataToSend: any) {
        const callUrl = this.baseURL + 'admin_unsuspend';
        const suspendBody = JSON.stringify(dataToSend);
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Token', this.dataService.getSessionIdentifier());
        return this.httpClient.post(callUrl, suspendBody, {headers});
    }

}
